import templateUrl from './boolean.tpl.html';

angular
    .module('festzelt-os.components')
    .component('filterBoolean', {
        bindings: {
            store: '<',
            col: '<',
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/filter-field/types/filter-type-boolean.js